(function () {
  'use strict';
  function addressCalculationFactory (
    $q,
    recipientsFactory,
    Common,
    $timeout,
    postalCodesFactory
  ) {
    const factory = {};
    let grossError, refinedError, grossCount, refinedCount;

    let isFetching = {
      gross: false,
      refined: false,
    };

    const addressLimit = recipientsFactory.addressLimit;

    // this is for saving the data to localStorage
    // ADR for now. add ODR when ready
    const addressTypeData = {
      ADR: 'adrData',
      ODR: 'odrData',
    };

    // this is for getting address count
    const getCountApi = {
      ADR: {
        INDIVIDUALS: recipientsFactory.getPotentialReach,
        COMPANIES: recipientsFactory.fetchCompanyAddressCount,
      },
      ODR: {
        INDIVIDUALS: recipientsFactory.getIndividualsCountOdr,
        COMPANIES: recipientsFactory.getCompanyCountOdr,
      },
    };

    function showError (rule, type) {
      switch (type) {
        case 'gross':
          if (isFetching.gross) return false;
          switch (rule) {
            case 'bad_request':
              return (
                grossError &&
                ((grossError.data || {}).errorMessage || {}).errorCode === 7
              );
            case 'generic_error':
              return grossError && grossCount === null;
            case 'min':
              return grossCount !== null && grossCount < addressLimit().min;
            default:
              return true;
          }
        case 'refined':
          if (isFetching.refined) return false;
          switch (rule) {
            case 'bad_request':
              return (
                refinedError &&
                ((refinedError.data || {}).errorMessage || {}).errorCode === 7
              );
            case 'generic_error':
              return refinedError && refinedCount === null;
            case 'min':
              return (
                refinedCount !== null &&
                refinedCount < addressLimit().min &&
                !showError('min', 'gross')
              );
            case 'max':
              return (
                refinedCount !== null && refinedCount >= addressLimit().max
              );
            default:
              return true;
          }
      }
    }

    function getCount (params) {
      return getCountApi[Common.get('recipients.addressType', 'ADR')][
        Common.get('recipients.targetType', 'INDIVIDUALS')
      ](params);
    }

    function generateId () {
      return Math.random().toString(36).substr(2, 8);
    }

    // this is for getting total count of addresses
    function computeGrossCount (params) {
      const addressType = Common.get('recipients.addressType');
      const reqZipcodes =
        addressType === 'ODR' ? params.zipcodes : postalCodesFactory.zipcodes;

      const reqParam = {
        zipcodes: (reqZipcodes || []).join(','),
      };

      if (addressType === 'ODR') {
        reqParam.postalCodeGroups = (params.postalCodeGroups || []).join(',');
      }

      // start loading
      isFetching.gross = true;

      getCount(reqParam)
        .then(function ({ recipientsCount }) {
          grossError = null;
          grossCount = recipientsCount;

          Common.set('recipients.grossAddressCount', recipientsCount);
          isFetching.gross = false;
        })
        .catch(function (err) {
          // ignore if request is cancelled
          if (err.status !== -1) {
            grossError = err;
            isFetching.gross = false;
          }
        });
    }

    // this is for the filtering addresses NOT for total count of address
    // this gets triggered when there is change with the filters
    function computeRefinedCount (params) {
      const addressType = Common.get('recipients.addressType');
      const targetType = Common.get('recipients.targetType');
      const reqZipcodes =
        addressType === 'ODR' ? params.zipcodes : postalCodesFactory.zipcodes;

      const reqParam = angular.copy(params);

      reqParam.zipcodes = (reqZipcodes || []).join(',');

      if (addressType === 'ADR' && targetType === 'INDIVIDUALS') {
        reqParam.id = generateId();
      }

      if (addressType === 'ODR') {
        reqParam.postalCodeGroups = (params.postalCodeGroups || []).join(',');
      }

      // start loading
      isFetching.refined = true;

      getCount(reqParam)
        .then(function ({ recipientsCount, blockCount }) {
          refinedCount = recipientsCount;
          refinedError = null;

          Common.set('recipients.refinedAddressCount', recipientsCount);
          Common.set('recipients.blockAddressCount', blockCount);
          Common.set(addressTypeData[addressType], reqParam);

          if (refinedCount <= addressLimit().max) {
            Common.notifyObserver('web2print.pricing');
          }

          isFetching.refined = false;
        })
        .catch(function (err) {
          // ignore if request is cancelled
          if (err.status !== -1) {
            refinedError = err;
            Common.set('recipients.refinedAddressCount', null);
            Common.set('recipients.blockAddressCount', null);

            isFetching.refined = false;
          }
        });
    }

    /*
      originalParams - zipcodes or parameters to be included in the api call
    */
    function computeAddressCount (originalParams) {
      const reqZipcodes =
        Common.get('recipients.targetType', '') === 'ODR'
          ? originalParams.zipcodes
          : postalCodesFactory.zipcodes;

      if (!reqZipcodes.length) {
        resetAddressCount();
        return;
      }

      computeGrossCount(originalParams);
      computeRefinedCount(originalParams);
    }

    function resetAddressCount () {
      grossCount = refinedCount = grossError = refinedError = null;
      isFetching.gross = isFetching.refined = false;
      Common.set('recipients.grossAddressCount', 0);
      Common.set('recipients.refinedAddressCount', 0);
      Common.set('recipients.blockAddressCount', 0);
      Common.set('recipients.odrGroup.postalcodeGroup', []);
      Common.set('recipients.odrGroup.postalcodes', []);
    }

    function getUpdateSyncParams () {
      return {
        isFetchingGrossCount: isFetching.gross,
        isFetchingRefinedCount: isFetching.refined,
      };
    }

    function getDefaultTab () {
      const serviceType = Common.get('serviceType');
      const odrTypes = ['admail-flyers', 'admail-odr'];
      let tab = 'FILE';

      if (serviceType.indexOf('admail-') > -1) {
        tab = odrTypes.indexOf(serviceType) >= 0 ? 'ODR' : 'ADR';
      }

      // saving default tab to be sure that it has data when it reaches distribution page
      Common.set('recipients.addressType', tab);

      return tab;
    }

    function formatNumberForSummary (numSource) {
      let val;

      switch (numSource) {
        case 'grossCount':
          val =
            Common.get('recipients.grossAddressCount', null) || grossCount || 0;
          break;
        case 'refinedCount':
          val =
            Common.get('recipients.refinedAddressCount', null) ||
            refinedCount ||
            0;
          break;
        default:
          val = 0;
      }

      if (numSource === 'refinedCount') {
        const max = addressLimit().max;
        const numParsed = Number(val);

        if (!refinedError && numParsed >= max) {
          return '≥ ' + recipientsFactory.formatNumberForSummary(max);
        }
      }

      return Common.formatNumber(val);
    }

    function setRefinedGross () {
      grossError = refinedError = null;
      refinedCount = Common.get('recipients.refinedAddressCount');
      grossCount = Common.get('recipients.grossAddressCount');
    }

    function resetFactoryVariables () {
      isFetching = {
        gross: false,
        refined: false,
      };

      grossError, refinedError, grossCount, (refinedCount = null);
    }

    function forceLoadCount () {
      isFetching = {
        gross: true,
        refined: true,
      };
    }

    function resetCount () {
      grossCount = refinedCount = null;
    }

    factory.computeAddressCount = computeAddressCount;
    factory.computeRefinedCount = computeRefinedCount;
    factory.showError = showError;
    factory.formatNumberForSummary = formatNumberForSummary;
    factory.getUpdateSyncParams = getUpdateSyncParams;
    factory.setRefinedGross = setRefinedGross;
    factory.resetFactoryVariables = resetFactoryVariables;
    factory.getDefaultTab = getDefaultTab;
    factory.forceLoadCount = forceLoadCount;
    factory.resetCount = resetCount;
    factory.resetAddressCount = resetAddressCount;

    return factory;
  }

  angular
    .module('web2print.recipients')
    .factory('addressCalculationFactory', addressCalculationFactory);
})();
